import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getProductionOrderDetail } from "../../../../services/production/productionService";

function SearchProductionOrderBom({ productionOrderID = 0, onSelectBom }) {
  const [boms, setBoms] = useState();
  const getProductionOrderData = async (productionOrderID = 0) => {
    const response = await getProductionOrderDetail(productionOrderID);
    const { data } = response.data;
    setBoms(data.productionOrder.boms);
  };
  useEffect(() => {
    getProductionOrderData(productionOrderID);
  }, [productionOrderID]);
  return (
    <React.Fragment>
      <CustomDataTableSearch
        data={boms}
        onRefreshData={() => {}}
        onSelectedData={(rowData, originalEvent) => {
          onSelectBom(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectBom(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Item ID",
            field: "reqItemID",
            body: null,
            sortable: true,
          },
          {
            header: "Item",
            field: "reqItemName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.reqItemName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
        ]}
      />
    </React.Fragment>
  );
}

export default SearchProductionOrderBom;
